import { blossom, branch, bud, petal, sword } from '../motifs';
import { M, PAPER, RED } from '../palette';
import { registerPlate } from '../registry';

/** 01 จอมยุทธ์: the martial artist's plate, a sword across warm paper with red plum blossoms. */
registerPlate({
  id: 'martial',
  name: 'จอมยุทธ์',
  ground: PAPER,
  trim: M.maroon,
  text: { fill: [M.maroon, M.ink], line: M.whiteHi },
  inset: [17, 11],
  front(p, f) {
    // Plum branches behind the sword's hilt and over the right end.
    branch(
      p,
      [
        [f.x + 1, f.y - 2],
        [f.x + 7, f.y - 6],
        [f.x + 15, f.y - 9],
      ],
      1.4,
      0.6,
    );
    branch(
      p,
      [
        [f.r + 5, f.y - 4],
        [f.r - 4, f.y - 1],
        [f.r - 10, f.y + 3],
      ],
      1.4,
      0.6,
    );
    branch(
      p,
      [
        [f.r + 2, f.b + 3],
        [f.r - 5, f.b - 2],
      ],
      1.2,
      0.6,
    );
    sword(p, [f.x - 7, f.b + 8], [f.x + 13, f.y - 6], { grip: 6 });
    blossom(p, f.x + 6, f.y - 6, 4, RED);
    blossom(p, f.x + 16, f.y - 8, 3.2, RED);
    blossom(p, f.x + 2, f.b - 2, 3.4, RED);
    bud(p, f.x + 10, f.y - 10, RED);
    blossom(p, f.r - 3, f.y - 1, 4, RED);
    blossom(p, f.r - 9, f.y + 3, 3.2, RED);
    blossom(p, f.r + 4, f.y - 5, 3, RED);
    blossom(p, f.r - 2, f.b - 1, 3.4, RED);
    bud(p, f.r + 3, f.b + 1, RED);
  },
  motion: {
    sprites: { petal: { w: 2, h: 2, draw: (p) => petal(p, 0, 0, RED) } },
    play(a, t, f) {
      for (let i = 0; i < 3; i++) {
        const ph = (t * 0.32 + i / 3) % 1;
        const x = f.r - 8 + i * 4 + Math.sin((t + i) * 2.4) * 1.5;
        a.spr('petal', x, f.y - 2 + ph * (f.h + 10), Math.min(1, (1 - ph) * 4));
      }
    },
  },
});
